export const ACCEPT_LANGUAGE_HEADER = 'accept-language';
export const ACCOUNT_HEADER = 'stripe-account';
export const LIVEMODE_HEADER = 'stripe-livemode';
export const STRIPE_VERSION_HEADER = 'stripe-version';
export const CONTEXT_HEADER = 'stripe-context';
